import type { CompanyType } from "~/services/customer/home";

export type CompanyCategory = {
  label: string;
  value: string | null;
  color: string;
  // provides[].name은 한글로 내려온다 (INFO_COMPANY: "호텔링"/"미용" 등, 마스터: "호텔"/"미용")
  names?: string[];
};

export const COMPANY_CATEGORIES: CompanyCategory[] = [
  { label: "전체", value: null, color: "#999999" },
  {
    label: "유치원",
    value: "PROVIDED_KINDERGARTEN",
    color: "#FF9934",
    names: ["유치원"],
  },
  {
    label: "데이케어",
    value: "PROVIDED_DAYCARE",
    color: "#3DCB7F",
    names: ["데이케어"],
  },
  {
    label: "호텔",
    value: "PROVIDED_HOTEL",
    color: "#7D6DFF",
    names: ["호텔", "호텔링"],
  },
  {
    label: "미용실",
    value: "PROVIDED_GROOMING",
    color: "#F24747",
    names: ["미용"],
  },
  {
    label: "동물병원",
    value: "PROVIDED_ANIMAL_HOSPITAL",
    color: "#378ADD",
    names: ["동물병원"],
  },
];

export const providesCategory = (
  company: CompanyType,
  category: CompanyCategory
) =>
  !!category.names &&
  !!company.provides?.some(
    (p) => category.names!.includes(p.name) && p.available
  );
